import { Component, Prop, Vue } from 'vue-property-decorator';
import {IWhiteboardUser} from '@/homework/interfaces/whiteboard-user.interface';
import {IOnlineHomework} from '@/homework/interfaces/online-homework.interface';
import {User} from '@/core/models/user.model';

@Component({})
export class BoardUsersMixin extends Vue {
    @Prop({required: true}) readonly boardGroupHash: string;
    @Prop() readonly classId: number;
    @Prop() readonly sectionId: number;
    @Prop() readonly homeworkOwner: string;
    @Prop() readonly homeworkId: number;

    get currentUser(): User {
        return this.$store.state.AuthStore.user;
    }

    get allOnlineHomeworks(): IOnlineHomework[] {
        return this.$store.state.HomeworksStore.onlineHomeworks;
    }

    get onlineHomeworks(): IOnlineHomework[] {
        let onlineHomeworks : IOnlineHomework[];
        if (this.boardGroupHash) {
            onlineHomeworks = this.allOnlineHomeworks.filter(v => v.homeworks.find(hw => hw.homeworkId == this.homeworkId));
        }
        else {
            onlineHomeworks = this.allOnlineHomeworks.filter(v => v.sectionId == this.sectionId);
        }
        return onlineHomeworks;
    }

    get usersConnected(): IWhiteboardUser[] {
        let users: IWhiteboardUser[] = [];
        for (const onlineHomework of this.onlineHomeworks) {
            onlineHomework.homeworks
                // No boardGroupHash means this.homeworkId is not actually a homework id
                .filter(detail => this.boardGroupHash ? (detail.homeworkId == this.homeworkId) : true)
                .forEach(detail => users = users.concat(detail.connected));
        }
        return [...new Set(users.filter(u => u.username != this.currentUser.userId))];
    }

    get usersOnline(): IWhiteboardUser[] {
        let users: IWhiteboardUser[] = [];
        for (const onlineHomework of this.onlineHomeworks) {
            onlineHomework.homeworks
                // No boardGroupHash means this.homeworkId is not actually a homework id
                .filter(detail => this.boardGroupHash ? (detail.homeworkId == this.homeworkId) : true)
                .forEach(detail => users = users.concat(detail.online));
        }
        return [...new Set(users)];
    }


    get isHomeworkOwnerConnected() : boolean {
        return this.usersOnline.findIndex(user => user.username === this.homeworkOwner) >= 0;
    }

    get users() {
        return this.usersConnected.map(user => ({...user, key: `${user.username}_${user.page}`}));
    }

    public obtainInitials(firstName: string, lastName: string) : string {
        return firstName && lastName
            ? `${firstName?.charAt(0).toUpperCase()}${lastName?.charAt(0).toUpperCase()}`
            : '?';
    }
}